import React, { createRef, useState } from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA14(props) {
  const [a14State, setA14State] = useState({ value: true });
  const messageRef = createRef();

  const onChangeHandler = (e) => {
    if (e.target.value !== "") {
      props.scrollToLatest();
      setA14State(prev => ({ ...prev, value: false }))
    } else {
      setA14State(prev=> ({ ...prev, value: true }))
    }
  }
  const onMouseEnterButton = (e) => {
    if (!e.target) {
      return
    }
    if (e.target.disabled === true) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA14ButtonMouseEnter.color ?? "#f8f5f5";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA14ButtonMouseEnter.background ?? "#2935dd";
  }

  const onMouseLeaveButton = (e) => {
    if (!e.target) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA14ButtonMouseLeave.color ?? "#0092ed";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA14ButtonMouseLeave.background ?? "#fff";
  }

  const messageBoxStyle = () => {
    return s360ConfigService.config?.customDesign?.messageA14Box
  }

  const formInputBoxStyle = () => {
    return {
      fontWeight: 500,
      ...s360ConfigService.config?.customDesign?.messageA14InputBox,
    }
  }

  const onInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      messageRef && messageRef.current && messageRef.current.blur();
      const ref = messageRef.current;
      onMouseLeaveButton(e);
      if (ref.value.trim().length > 0) {
        props.actions.sendMessage(ref.value.trim());
      }
    }
  }

  const onClickInput = () => {
    setA14State(prev => ({ ...prev, value: false }));
  }

  const onSubmit = (e) => {
    const ref = messageRef.current;
    onMouseLeaveButton(e);
    if (ref.value.trim().length > 0) {
      props.actions.sendMessage(ref.value.trim());
    }
  }

  const messageBoxSubmitStyle = () => {
    return {
      marginLeft: '15px',
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      ...s360ConfigService.config?.customDesign?.messageA14Submit
    }
  }

  return (
    <div className="s360-message-cotainer-received">
      <div className="s360-message-box-custom-a14-received" style={messageBoxStyle()}>
        <input
          onFocus={e => e.currentTarget.select()}
          type="text" ref={messageRef}
          onChange={(e) => onChangeHandler(e)}
          className="s360-message-box-custom-a14-textbox-input" onClick={onClickInput}
          onKeyDown={onInputKeyPress} style={formInputBoxStyle()}/>
      </div>
      {props.isLastEntry && props.sentTimestamp &&
                <div 
                  // className={messageTimeClassName()} style={messageTimeStyle()} // TODO: check implementation
                >
                  {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
                </div>}
      <div className="s360-message-cotainer-received">
        <button disabled={a14State.value || props.disabled}
          className="s360-message-box-custom-a15-received" onClick={onSubmit}
          onMouseEnter={onMouseEnterButton} onMouseLeave={onMouseLeaveButton}
          style={messageBoxSubmitStyle()}>
          {(props.entry.data) ? JSON.parse(props.entry.data).buttonText : 'Submit'}
        </button>
      </div>
    </div>
  );
}

export default MessageA14;
